import { useNavigate } from '~hooks'
import { get } from 'lodash'
import { useEffect } from 'react'
import { useStore } from '~hooks'

const OPTIONS = {
  cpf: '/entrar',
  plate: '/entrar',
  login: {
    blockedTime: '/entrar',
  },
  register: {
    cellphone: '/cadastrar',
    fullName: '/cadastrar/nome-completo',
    plate: '/cadastrar/placa',
    rntrc: '/cadastrar/rntrc',
    vehicleType: '/cadastrar/tipo-veiculo',
    vehicleBody: '/cadastrar/tipo-carroceria',
    vehicleTracking: '/cadastrar/rastreador-veiculo',
    selfie: '/cadastrar/selfie/tirar',
  },
  passwordRecovery: {
    blockedTime: '/recuperar-senha-motorista/celulares',
    cellphone: '/recuperar-senha-motorista/celulares',
  },
}

export default function usePathValidation(dependencies: string[]) {
  const store = useStore()
  const navigate = useNavigate()
  const firstEmptyDependency = dependencies.find(
    (dependency) => get(store, dependency) == null,
  )

  useEffect(() => {
    if (firstEmptyDependency) {
      navigate(get(OPTIONS, firstEmptyDependency) as string)
    }
  }, [navigate, firstEmptyDependency])
}
